import { CloseIcon } from 'components/icons';
import { useEffect, type FC, useRef } from 'react';
import styles from './ModalFullScreen.module.css';
import { type ModalProps } from './types';

const ModalFullScreen: FC<ModalProps> = ({ onClose, children }) => {
  useEffect(() => {
    const body = document.querySelector('body');
    if (body) {
      body.style.overflow = 'hidden';
    }
    return () => {
      if (body) {
        body.style.overflow = 'auto';
      }
    };
  }, []);

  const modalRef = useRef(null);
  useEffect(() => {
    const handleOutsideClick = (event: { target: any }) => {
      // @ts-ignore
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        if (onClose) onClose();
      }
    };
    window.addEventListener('mousedown', handleOutsideClick);
    return () => {
      window.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [modalRef, onClose]);

  return (
    <div className={styles.module}>
      <div ref={modalRef} className={styles.container}>
        <div className={styles.closeButton} onClick={onClose}>
          <CloseIcon />
        </div>
        {children}
      </div>
    </div>
  );
};

export default ModalFullScreen;
